
export enum CompanionStage {
  EGG = 'EGG',
  BABY = 'BABY',
  FLYING = 'FLYING',
  MASTER = 'MASTER'
}

export type Language = 'en' | 'zh';
export type Theme = 'light' | 'dark';

export type SubjectType = 'math' | 'chinese' | 'english' | 'science' | 'history' | 'art';

export interface UserStats {
  math: number;
  chinese: number;
  english: number;
  science: number;
  history: number;
  art: number;
  nature?: number;
  focus_minutes: number;
  tasks_completed: number;
}

export interface UserProfile {
  uid: string;
  name: string;
  grade: number;
  age: number;
  interests: string[];
  avatar: string;
  level: number;
  xp: number;
  energy: number;
  maxEnergy: number;
  streak: number;
  skills: string[];
  stats: UserStats;
}

export interface CurriculumNode {
  id: string;
  title: string;
  desc: string;
  level: number;
  prev: string | null;
}

export interface CurriculumSubject {
  title: string;
  desc: string;
  color: string;
  nodes: CurriculumNode[];
}

export type CurriculumData = Record<SubjectType, CurriculumSubject>;

export interface DailyTask {
  id: string;
  subject: SubjectType;
  desc: string;
  completed: boolean;
  createdAt: number;
}

export interface LessonWidget {
  type: 'text' | 'comic_strip' | 'visual_image' | 'magic_formula' | 'vocab_card' | 'step_guide' | 'did_you_know' | 'quiz' | 'step_solver' | 'voice_practice' | 'canvas';
  data: any;
}

export interface QuizItem {
  q: string;
  options: string[];
  a: number;
  success_msg?: string;
}

export interface LessonContent {
  mode: 'study';
  title: string;
  category: string;
  intro_story: string;
  core_concept: string;
  widgets: LessonWidget[];
  quiz?: QuizItem[];
  mission: string;
}

export interface ChatMessage {
  role: 'user' | 'model';
  text: string;
}

export interface CognitiveStage {
  name: string;
  focus: string;
  desc: string;
}

export interface GrowthProjection {
  timeline: {
    current: string;
    threeMonth: string;
    oneYear: string;
    threeYear: string;
  };
  cognitive_stage: CognitiveStage;
}
